import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { GlobalName } from '../utils/global-name';
import { LocalStorageService } from '../utils/local-stoarge-service';
import { AppRedirect } from '../utils/app-redirect';

export const isAuthedGuard: CanActivateFn = (_route, _state) => {
  const lsService = inject(LocalStorageService);
  const router = inject(Router);

  if (lsService.get(GlobalName.tokenName) != null) {
    const url = AppRedirect.redirectLogin(lsService);
    return router.createUrlTree([url]);
  }
  return true;
};
